import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TransactionResult } from '../data/transaction-result';
import { MessageManagementService } from './message-management.service';
import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';

@Injectable({
  providedIn: 'root'
})
export class RestCallService {

  private urlBase: string;

  constructor(public http: HttpClient,
    public toastr: NbToastrService,
    private notificationService: MessageManagementService,
  ) {
    this.urlBase = environment.apiEndpoint;
    if (!Boolean(this.urlBase)) {
      throw Error("property urlBase:string is not defined inside enviroment variables");
    }
  }

  private getFullUrl(url: string): string {
    return this.urlBase + url;
  }

  /** Error handling was delegated to "interceptor" */
  private error(error: HttpErrorResponse): void {
    if (null != error) {
      console.error(error);
      if (error.status === 401) {
        console.error("401", error.message);
      }
      if (error.status === 500) {
        this.toastr.danger(error.message);
      }
      if (error.status === 404) {
        this.toastr.info(error.message);
      }
      if (error.status === 0) {
        this.toastr.info(error.message);
      }
      if (error.status === 405) {
        this.toastr.info(error.message);
      }
    }
  }


  /**
   * HTTP GET Call
   * @param url Url of the End-Point
   * @param data Data to be sent for this call
   * @param headers Define additional headers
   * @returns TransactionResult with the Data defined
   */
  public get<TResult>(url: string, data?: any, headers?: HttpHeaders | any): Observable<TransactionResult<TResult>> {
    if (!Boolean(headers)) {
      headers = {};
    }
    return this.http.get<TransactionResult<TResult>>(this.getFullUrl(url), {
      headers: Object.assign(headers, {
        'urlBase': this.urlBase
      }),
      params: data
    }).pipe(tap({ error: (err) => this.error(err) }));
  }

  /**
   * HTTP POST Call
   * @param url Url of the End-Point
   * @param data Data to be sent for this call
   * @param headers Define additional headers
   * @returns TransactionResult with the Data defined
   */
  public post<TResult>(url: string, data?: any, headers?: HttpHeaders | any): Observable<TransactionResult<TResult>> {
    if (!Boolean(headers)) {
      headers = {};
    }
    return this.http.post<TransactionResult<TResult>>(this.getFullUrl(url), data, {
      headers: {
        'urlBase': this.urlBase
      }
    }).pipe(tap({ error: (err) => this.error(err) }));
  }


  /**
   * HTTP PUT Call
   * @param url Url of the End-Point
   * @param data Data to be sent for this call
   * @param headers Define additional headers
   * @returns TransactionResult with the Data defined
   */
  public put<TResult>(url: string, data?: any, headers?: HttpHeaders | any): Observable<TransactionResult<TResult>> {
    if (!Boolean(headers)) {
      headers = {};
    }
    return this.http.put<TransactionResult<TResult>>(this.getFullUrl(url), data, {
      headers: {
        'urlBase': this.urlBase
      }
    }).pipe(tap({ error: (err) => this.error(err) }));
  }


  /**
   * HTTP DELETE Call
   * @param url Url of the End-Point
   * @param params Data to be sent for this call
   * @param headers Define additional headers
   * @returns TransactionResult with the Data defined
   */
  public delete<TResult>(url: string, params?: any, headers?: HttpHeaders | any): Observable<TransactionResult<TResult>> {
    if (!Boolean(headers)) {
      headers = {};
    }
    return this.http.delete<TransactionResult<TResult>>(this.getFullUrl(url), {
      headers: {
        'urlBase': this.urlBase
      }, params: params
    }).pipe(tap({ error: (err) => this.error(err) }));
  }
}
